import * as THREE from 'three';

export function generarMapaCielo(scene, renderer) {

  // -------------------------------------------------------
  // 1) LIMPIAR LUCES PREVIAS
  // -------------------------------------------------------
  const lucesParaEliminar = [];
  scene.traverse(obj => { if (obj.isLight) lucesParaEliminar.push(obj); });
  lucesParaEliminar.forEach(l => scene.remove(l));

  scene.fog = null;

  if (renderer) {
    renderer.setClearColor("#fcd3b5");
    renderer.toneMapping = THREE.ACESFilmicToneMapping;
    renderer.toneMappingExposure = 1.1;
  }

  // -------------------------------------------------------
  // 2) GEOMETRÍA ESFÉRICA
  // -------------------------------------------------------
  const radio = 340;
  const detalle = 5;

  const geometry = new THREE.IcosahedronGeometry(radio, detalle);

  function ruido3D(x, y, z) {
    return (
      Math.sin(x * 0.012 + y * 0.015) +
      Math.cos(y * 0.018 - z * 0.012)
    ) * 0.5;
  }

  const pos = geometry.attributes.position;
  for (let i = 0; i < pos.count; i++) {
    const x = pos.getX(i);
    const y = pos.getY(i);
    const z = pos.getZ(i);
    const f = 1 + ruido3D(x, y, z) * 0.04;
    pos.setXYZ(i, x * f, y * f, z * f);
  }
  pos.needsUpdate = true;
  geometry.computeVertexNormals();

  // -------------------------------------------------------
  // 3) SHADER MATERIAL (CORREGIDO)
  // -------------------------------------------------------
  const skyMaterial = new THREE.ShaderMaterial({
    side: THREE.BackSide,
    depthWrite: false,
    depthTest: false,

    uniforms: {
      radius: { value: radio },

      // 🌅 Paleta corregida (sin rosa fuerte)
      c1: { value: new THREE.Color("#ff8c42") }, // naranja horizonte
      c2: { value: new THREE.Color("#ffb347") }, // naranja dorado suave
      c3: { value: new THREE.Color("#4ce0e5") }, // turquesa
      c4: { value: new THREE.Color("#1e63b8") }, // azul cielo

      sunDir: { value: new THREE.Vector3(1, 0.3, 0.2).normalize() }
    },

    vertexShader: `
      varying float vY;
      varying vec3 vNormal;

      void main() {
        vY = position.y;
        vNormal = normal;
        gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
      }
    `,

    fragmentShader: `
      uniform float radius;

      uniform vec3 c1;
      uniform vec3 c2;
      uniform vec3 c3;
      uniform vec3 c4;

      uniform vec3 sunDir;

      varying float vY;
      varying vec3 vNormal;

      void main() {

        // --------------------------------------------------
        // GRADIENTE AJUSTADO (más control en horizonte)
        // --------------------------------------------------
        float h = clamp((vY + radius) / (radius * 2.0), 0.0, 1.0);

            vec3 col;

            // 🔥 Horizonte MUY abajo (naranja comprimido)
            if (h < 0.13) {
              col = c1; // naranja fuerte solo cerca del horizonte
            }
            else if (h < 0.32) {
              col = mix(c1, c2, (h - 0.18) / 0.14);
            }
            else if (h < 0.65) {
              col = mix(c2, c3, (h - 0.32) / 0.33);
            }
            else {
              col = mix(c3, c4, (h - 0.65) / 0.35);
            }

        // --------------------------------------------------
        // ILUMINACIÓN SUAVE
        // --------------------------------------------------
        vec3 N = normalize(vNormal);
        vec3 L = normalize(sunDir);

        float dif = max(dot(N, L), 0.0);
        float hemi = 0.5 + 0.5 * N.y;

        float lighting = 0.70 + dif * 0.25 + hemi * 0.15;

        col *= lighting;

        gl_FragColor = vec4(col, 1.0);
      }
    `
  });

  // -------------------------------------------------------
  // 4) SKYBOX
  // -------------------------------------------------------
  const skyMesh = new THREE.Mesh(geometry, skyMaterial);
  skyMesh.scale.set(-1, 1, 1);
  skyMesh.frustumCulled = false;
  skyMesh.renderOrder = -9999;
  scene.add(skyMesh);

  skyMesh.userData.rotSpeed = 0.00003;

  if (typeof animate === 'function') {
    const originalAnimate = animate;
    animate = function () {
      skyMesh.rotation.y += skyMesh.userData.rotSpeed;
      originalAnimate();
    };
  }

  // -------------------------------------------------------
  // 5) LUCES DE ESCENA
  // -------------------------------------------------------

  const ambientLight = new THREE.AmbientLight(0xffe0d2, 1.0);
  scene.add(ambientLight);

  const sunLight = new THREE.DirectionalLight(0xffd2a6, 0.8);
  sunLight.position.set(15, 25, 10);
  scene.add(sunLight);

  const skyLight = new THREE.DirectionalLight(0x8fe8ff, 0.35);
  skyLight.position.set(-25, 30, -20);
  scene.add(skyLight);
}